import { FaEnvelope, FaUsers } from "react-icons/fa";
import SubscriberManagement from "../components/settings/SubscriberManagement";
import UserManagement from "../components/settings/UserManagement";
import DisplayHtmlAndSwiperPage from "../pages/DisplayHtmlAndSwiperPage";
import GridPage from "../pages/GridPage";
import MapPage from "../pages/MapPage";
import SettingsPage from "../pages/SettingsPage";
import NotFoundPage from "../pages/errors/NotFoundPage";
import { getAllSubs } from "../services/subsService";
import { getAllUsers } from "../services/userService";
import { getAllWhatToDosShort, getWhatToDoById } from "../services/whatToDoService";
import AlertView from "../components/settings/AlertView";
import { getAllAllarmeteo } from "../services/allarmeteoService";
import { getAllAlerts } from "../services/alertsService";
import { GoAlert } from "react-icons/go";
import { AiTwotoneAlert } from "react-icons/ai";
import { LuBellPlus } from "react-icons/lu";
import AlertCreate from "../components/settings/AlertCreate";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import ReportsManager from "../components/settings/ReportsManager";
import { FaRegPaperPlane } from "react-icons/fa";
import { getAllPcesShort, getPceById } from "../services/pceService";
import MonitorPage from "../pages/MonitorPage";
import ActionsManagement from "../components/settings/ActionsManagement";
import { GrAction } from "react-icons/gr";
import { getAllActions } from "../services/actionsService";
import { BsEnvelopeAt } from "react-icons/bs";
import { getAllReports } from "../services/reportsService";
import MailManagement from "../components/settings/MailManagement";
import { getPossiblesCommunications } from "../services/communicationsService";
import { getAllSettings } from "../services/settingsService";
import SettingsManagement from "../components/settings/SettingsManagement";
import { RiSettings5Line } from "react-icons/ri";

const routesConfig = [
	{
		component: GridPage,
		props: {},
		name: "Home",
		route: "/",
		requiresAuth: false,
		showInMenu: true,
	},
	{
		component: SettingsPage,
		props: {
			title: "Gestione Sistema",
			menu: [
				{
					label: "Allerte Regionali",
					tab: "allarmeteo",
					icon: <GoAlert />,
					getAll: getAllAllarmeteo,
					component: AlertView,
					props: {
						editable: false,
					},
					autoUpdate: true,
				},
				{
					label: "Allerte Comunali",
					tab: "alerts",
					icon: <AiTwotoneAlert />,
					getAll: getAllAlerts,
					component: AlertView,
					props: {
						editable: true,
					},
					autoUpdate: true,
				},
				{
					label: "Crea Allerta",
					tab: "new-alert",
					icon: <LuBellPlus />,
					component: AlertCreate,
					props: {
						editable: true,
					},
				},
				{
					label: "Segnalazioni",
					tab: "reports",
					icon: <FaRegPaperPlane />,
					getAll: getAllReports,
					component: ReportsManager,
					props: {},
					autoUpdate: true,
				},
			],
		},
		name: "Gestione Sistema",
		route: "/alerts",
		notification_key: "manager",
		showInMenu: true,
		requiresAuth: true,
		minLevel: 2,
	},
	{
		component: MapPage,
		props: {},
		name: "Mappa",
		route: "/map",
		showInMenu: true,
		requiresAuth: true,
		minLevel: 2,
	},
	{
		component: SettingsPage,
		props: {
			menu: [
				{
					label: "Gestione Utenti",
					tab: "users",
					icon: <FaUsers />,
					getAll: getAllUsers,
					component: UserManagement,
					props: {},
				},
				{
					label: "Gestione Iscrizioni",
					tab: "subs",
					icon: <FaEnvelope />,
					getAll: getAllSubs,
					component: SubscriberManagement,
					props: {},
				},
				{
					label: "Gestione Azioni",
					tab: "actions",
					icon: <GrAction />,
					getAll: getAllActions,
					component: ActionsManagement,
					props: {},
					autoUpdate: true,
				},
				{
					label: "Gestione Comunicazioni",
					tab: "communications",
					icon: <BsEnvelopeAt />,
					getAll: getPossiblesCommunications,
					component: MailManagement,
					props: {},
				},
				{
					label: "Impostazioni di Sistema",
					tab: "settings",
					icon: <RiSettings5Line />,
					getAll: getAllSettings,
					component: SettingsManagement,
					props: {},
				},
			],
		},
		name: "Impostazioni",
		route: "/settings",
		notification_key: "settings",
		showInMenu: true,
		requiresAuth: true,
		minLevel: 1,
	},
	{
		component: DisplayHtmlAndSwiperPage,
		props: {
			getAll: getAllWhatToDosShort,
			getSelected: getWhatToDoById,
			path: "/what-to-do",
			title: "Cosa fare in caso di",
		},
		name: "Cosa Fare in caso di ...",
		route: "/what-to-do/:id",
		showInMenu: false,
		requiresAuth: false,
	},
	{
		component: DisplayHtmlAndSwiperPage,
		props: { getAll: getAllPcesShort, getSelected: getPceById, path: "/pce" },
		name: "Piano Comunale di Emergenza",
		route: "/pce/:id",
		showInMenu: false,
		requiresAuth: false,
	},
	{
		component: MonitorPage,
		props: {},
		name: "Monitor",
		route: "/monitor",
		showInMenu: false,
		requiresAuth: false,
	},
	{
		component: PrivacyPolicyPage,
		props: {},
		name: "Privacy Policy",
		route: "privacy-policy",
		showInMenu: false,
		requiresAuth: false,
	},
	{
		component: NotFoundPage,
		props: {},
		name: "Errore",
		route: "*",
		showInMenu: false,
		requiresAuth: false,
	},
];

export { routesConfig };
